<template>
    <date-picker
        lang="ru"
        v-bind:value="value"
        v-model="date"
        :input-class="value && !disableHighlighting ? 'mx-input-yel' : ''"
        @change="$emit('change', date)"
        @input="$emit('input', date)"
        valueType="format"
        :format="format"
        :class="{empty: !!!value}"
        :disabled-date="disabledDate"
        :disabled="disabled"
        ref="popup"
        :open="visible"
        :clearable="clearable"
    />
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';

export default {
  name: "DatePiker",
    props: {
      value: { type: String, default: '' },
      format: { type: String, default: 'DD.MM.YYYY' },
      disabledDate: { type: Function, default: () => false },
      disabled: { type: Boolean, default: false },
      inputAttr: { type: Object, default: () => {} },
      disableHighlighting: { type: Boolean, default: false },
      clearable: { type: Boolean, default: true },
      defaultValue: { type: String, default: '' },
    },

    model: {
        prop: 'value',
        event: 'change'
    },

    components: { DatePicker },

    data() {
      let date;

      if (!this.value) {
          date = null;
      } else if (this.value.indexOf('.') !== -1) {
          let dateParts = this.value.split('.');
          date = this.$moment(new Date(dateParts[2], dateParts[1] - 1, dateParts[0])).format(this.format);
      } else {
          date = this.$moment(new Date(this.value)).format(this.format);
      }

        return {
            date: date,
            visible: undefined,
        }
    },

    created() {
      this.$bus.$on('focusOnElement', () => {
        this.$refs.popup.closePopup()
      })
    },
    watch: {
      'date' (n) {
          this.date = !this.clearable && !n && this.defaultValue ? this.defaultValue : n;
      },
      'value' (n) {
          this.date = !this.clearable && !n && this.defaultValue ? this.defaultValue : n;
      },
      'visible' (n) {
          if (n === false) {
              this.visible = undefined;
              this.$refs.popup.closePopup();
          }
      },
    },

    methods: {
      closePopupHandler: function () {
          this.$store.commit('hideComponent/remove');
      },
      openPopupHandler: function () {
          this.$store.commit('hideComponent/add', this);
      },
    },

    mounted() {
        this.$refs.popup.$on('open', this.openPopupHandler)
        this.$refs.popup.$on('close', this.closePopupHandler);
    },
}
</script>
